module.exports = __webpack_public_path__ + "static/media/more-icon.3fe78239.svg";